export function buildAppIdentifierString(platformDetails?: string | null, deviceType?: string | null) {
  if (deviceType === "ios") {
    const [device, version, versionNumber] = platformDetails?.split(" ") || [];
    const match = device.match(/([a-zA-Z]+)(\d+)/); // Separate the device name and number
    if (match) {
      const [, deviceName, deviceNumber] = match;
      return `${deviceName} ${deviceNumber}, ${version} ${versionNumber}`;
    }
  }
  return platformDetails ?? "Unknown Device"; // Fallback if the format doesn't match
}
